import { DetailedSubscriptionChain, SummarySubscription } from '../../types/types'

export const mapChainDetailedToSubscriptions = (chainDetailed?: DetailedSubscriptionChain): SummarySubscription[] => {
  return chainDetailed?.subscriptions?.map((sub) => ({
    id: sub.id,
    chainId: chainDetailed.id,
    startAt: sub.startAt,
    endAt: sub.endAt,
    subscriptionLength: sub.subscriptionLength,
    paymentReference: sub.paymentReference,
    notes: sub.notes,
    dashboardRobot: chainDetailed.dashboardRobot,
    relation: chainDetailed.relation,
    shippedAt: sub.shippedAt,
    hardwareType: chainDetailed.hardwareType,
    parentId: sub.parentId
  }))
}
